module.exports = "/virtual-football-league/img/amblems/left/France/Fake_Marseille.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/France/Fake_Marseille.png
// module id = 2032
// module chunks = 4